import { useMutation } from '@apollo/client';
import { Button, Col, Form, Input, Row } from 'antd';
import { useContext, useState } from 'react';
import { useWindowSize } from 'react-use';
import { UpdateUserInput } from '../../__generated__/graphql';
import { AppContext } from '../../AppContext';
import LOGO from '../../assets/svg/vastu-logo.svg';
import { REGEX, ROUTES } from '../../common/constants';
import { isMobileBrowser } from '../../common/utils';
import { customizeRequiredMark } from '../../components/CustomRequiredMark';
import useRouter from '../../hooks/useRouter';
import { AppActionType, AppContextType } from '../../types/appContext.type';
import '../auth/auth.less';
import AuthSlider from './AuthSlider';
import { UPDATE_USER } from './graphql/mutations';

export default function Signup() {
  const { width } = useWindowSize();
  const { dispatch } = useContext(AppContext) as AppContextType;
  const { navigate } = useRouter();
  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: ({ updateUserWeb }) => {
      dispatch({
        type: AppActionType.setCurrentUser,
        data: updateUserWeb?.data ?? {},
      });
    },
  });
  const [loading, setLoading] = useState<boolean>(false);

  const handleUpdateUser = async (values: UpdateUserInput) => {
    try {
      setLoading(true);
      await updateUser({
        variables: {
          data: {
            firstName: values?.firstName,
            lastName: values?.lastName,
          },
        },
      });
      setLoading(false);
      navigate(ROUTES.MAIN);
    } catch (_E) {
      setLoading(false);
    }
  };

  return (
    <div className="sign-up-container">
      <Row>
        {!isMobileBrowser(width) && (
          <Col span={12} className="slider">
            <AuthSlider />
          </Col>
        )}
        <Col xs={24} md={12} className="sign-up-div">
          {isMobileBrowser(width) && (
            <div className="logo-wrapper">
              <img src={LOGO} alt="logo" className="main-logo"></img>
            </div>
          )}
          <Form
            name="sign-up-form"
            className="signup-form-div"
            layout="vertical"
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 20 }}
            onFinish={(values) => handleUpdateUser(values)}
            requiredMark={customizeRequiredMark}
          >
            <div className="signup-form">
              <h1 className="title-lg semibold">Tell us about yourself</h1>
              <div className="first-name-input ">
                <Form.Item
                  label={<span className="body-meta medium">First Name</span>}
                  name="firstName"
                  required
                  rules={[
                    { required: true, message: 'First Name is required' },
                    {
                      pattern: REGEX.NAME,
                      message: 'Please enter a valid first name',
                    },
                  ]}
                >
                  <Input placeholder="Enter your First Name" />
                </Form.Item>
              </div>
              <div className="last-name-input">
                <Form.Item
                  label={<span className="body-meta medium">Last Name</span>}
                  name="lastName"
                  required
                  rules={[
                    { required: true, message: 'Last Name is required' },
                    {
                      pattern: REGEX.NAME,
                      message: 'Please enter a valid last name',
                    },
                  ]}
                >
                  <Input placeholder="Enter your Last Name" />
                </Form.Item>
              </div>
            </div>
            <div>
              <Button
                className="signup-button medium"
                htmlType="submit"
                loading={loading}
                type="primary"
              >
                Sign up
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
